import React from "react";

export const DropShadow = ({
  isDisabled,
  shadowCoords,
  shadowWidth,
  resultName
}) => {
  if (isDisabled || !shadowCoords) return null;

  return (
    <feDropShadow
      dx={shadowCoords.x}
      dy={shadowCoords.y}
      stdDeviation={shadowWidth}
      result={resultName}
    />
  );
};

export default DropShadow;
